;(function () {
  'use strict'
  angular.module('contrast.app-environment').constant('APP_ENVIRONMENT_TYPE', {
    ATTACKS: 'ATTACKS',
    VULNERABILITIES: 'VULNERABILITIES'
  })
})()
